 // 1. Đăng ký Plugin GSAP
 gsap.registerPlugin(ScrollTrigger);

 // 2. Định nghĩa Custom Element (Phiên bản linh hoạt - Slot based)
 class ZoomCard extends HTMLElement {
     constructor() {
         super();
     }

     connectedCallback() {
         // Bước 1: Lấy nội dung HTML gốc bên trong thẻ <zoom-card>
         const originalContent = this.innerHTML;
         
         // Bước 2: Xóa nội dung cũ để chuẩn bị render cấu trúc mới
         this.innerHTML = '';

         // Bước 3: Tạo cấu trúc Wrapper (Vỏ bọc hiệu ứng)
         // Wrapper ngoài cùng để scale
         const wrapper = document.createElement('div');
         wrapper.className = 'zoom-wrapper';
         
         // Content box: nơi chứa nội dung của bạn
         // Chiều cao cố định (h-[60vh]) để đảm bảo layout đẹp khi scroll
         const cardContent = document.createElement('div');
         cardContent.className = 'card-content';
         
         // Đưa nội dung gốc vào trong cardContent
         cardContent.innerHTML = originalContent;
         
         // Gắn lại vào DOM
         wrapper.appendChild(cardContent);
         this.appendChild(wrapper);

         // --- GSAP ANIMATION LOGIC ---
         // Chỉ tìm các phần tử con có class đặc biệt 'anim-reveal' để animate (nếu có)
         const revealElements = cardContent.querySelectorAll('.anim-reveal');

         // Logic Scroll:
         // Start: Top element chạm Bottom viewport
         // End: Center element chạm Center viewport
         
         const tl = gsap.timeline({
             scrollTrigger: {
                 trigger: wrapper,
                 start: "top bottom", 
                 end: "center center",
                 scrub: 1, 
             }
         });

         // Hiệu ứng chính: Phóng to Wrapper
         tl.fromTo(wrapper, 
             { scale: 0.5, opacity: 1, borderRadius: 9999 }, 
             { scale: 1, opacity: 1, duration: 1, ease: "power1.out", borderRadius: 0 } 
         );

         // Hiệu ứng phụ: Nếu có phần tử class 'anim-reveal', cho nó bay lên
         if (revealElements.length > 0) {
             tl.to(revealElements, { y: 0, opacity: 1, duration: 0.8, stagger: 0.1 }, "<0.2");
         }
     }
 }

 customElements.define('zoom-card', ZoomCard);

 // 3. Cấu hình Lenis Smooth Scroll (Đã hợp nhất với code của bạn)
 const lenis = new Lenis({
     duration: 1.2,
     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
     direction: "vertical",        // Option từ code của bạn
     gestureDirection: "vertical", // Option từ code của bạn
     smooth: true,                 // Option từ code của bạn
     smoothWheel: true,            // Đảm bảo tương thích bản mới nhất
 });

 // Tích hợp ScrollTrigger: Update GSAP khi Lenis scroll
 lenis.on('scroll', (e) => {
     ScrollTrigger.update();
     // Nếu muốn log scroll event như code cũ của bạn, bỏ comment dòng dưới:
     // console.log(e);
 });

 // 4. Vòng lặp RAF (Sử dụng GSAP Ticker thay vì requestAnimationFrame thủ công)
 // Cách này giúp đồng bộ hoàn hảo giữa Lenis và ScrollTrigger
 gsap.ticker.add((time) => {
     lenis.raf(time * 1000); // Chuyển đổi time sang milliseconds
 });

 // Tắt lag smoothing của GSAP để tương thích tốt hơn với Lenis
 gsap.ticker.lagSmoothing(0);
